<!--
 * @Author: guoyu
 * @Date: 2020-05-15 10:39:09
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 15:23:11
 * @Description: 用户優惠券
 -->
<template>
  <div class="coupon-page">
    <div class="user-coupons">
      <div class="tabs-container">
        <Tabs
          v-model="tabVal"
          class="tabs-wrap"
          :options="tabOptions"
        />
        <button class="get-coupons" @click="showCodeInput = true">{{$t('upgrade_page_views_coupons_index_700')}}</button>
      </div>
      <div v-if="options.length" class="coupons-list-wrap">
        <CouponsBar
          v-for="(item, i) in options"
          class="coupon-bar"
          :key="(tabVal === 1 ? 'canuse' : 'cannotuse') +  '-'+ item.uuid + '-' + i"
          :couponsInfo="item"
          :noUseButton="tabVal === 1"
          :checked="false"
          :disabled="tabVal === 1"
          :count="item.count"
          @use="gotoPlayDetail(item)"
        ></CouponsBar>
      </div>
      <div class="no-coupons" v-else>
        <div class="no-coupons-icon"></div>
        <div>{{tabVal===1? $t('upgrade_page_views_coupons_index_701') : $t('upgrade_page_views_coupons_index_702')}}</div>
      </div>
      <el-dialog
        :visible.sync="showCodeInput"
        custom-class="dialog-clear-style"
        :show-close="false"
        width="420px"
        append-to-body
      >
        <div class="input-coupon-code">
          <button class="close-dialog" @click="showCodeInput = false">
            <fps-icon type="close" size="18" />
          </button>
          <div class="coupon-title">{{$t('upgrade_page_views_coupons_index_700')}}</div>
          <div class="code-err" :style="{ visibility: showError ? 'visible' : 'hidden' }">{{ errorText }}</div>
          <input v-model="collectionCode" class="code-input" :class="showError && 'error-input'" type="text" :placeholder="$t('upgrade_page_views_coupons_index_703')">
          <button class="get-btn" :disabled="!collectionCode" @click="getCoupon">
            <i v-if="gettingCoupon" class="el-icon-loading"></i>
            <span v-else>{{$t('upgrade_page_views_coupons_index_704')}}</span>
          </button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import Tabs from '@/components/Tabs'
import CouponsBar from '@/upgrade-page/views/order/components/coupons/bar'

export default {
  components: { CouponsBar, Tabs },
  data() {
    const tabOptions = [
      {
        label: i18n.t('upgrade_page_views_coupons_index_705'),
        value: 0,
      },
      {
        label: i18n.t('upgrade_page_views_coupons_index_706'),
        value: 1,
      },
    ]
    return {
      showError: false,
      collectionCode: '',
      showCodeInput: false,
      tabVal: tabOptions[0].value,
      tabOptions,
      headOptions: [
        { label: i18n.t('upgrade_page_views_coupons_index_707'), key: 'couponName', width: 180 },
        { label: i18n.t('upgrade_page_views_wallet_index_692'), key: 'couponAmount', width: 120 },
        { label: i18n.t('upgrade_page_views_coupons_index_708'), name: 'validityCalculationDesc', width: 180},
        { label: i18n.t('upgrade_page_views_coupons_index_709'), key: 'useConditionDesc', width: 362 },
        { label: i18n.t('upgrade_page_views_coupons_index_710'), key: '', name: 'status' },
      ],
      couponsList: [],
      invalidList: [],
      gettingCoupon: false,
      errorText: i18n.t('upgrade_page_views_coupons_index_711'),
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'abTest']),
    options() {
      // 有效優惠券
      if (this.tabVal === 0) {
        return this.couponsList;
      }
      // 失效優惠券
      return this.invalidList;
    },
  },
  // watch: {
  //   showCodeInput(show) {
  //     if (!show) {
  //       this.showError = false
  //       this.collectionCode = ''
  //     }
  //   }
  // },
  methods: {
    getCoupon() {
      if (this.gettingCoupon) return
      this.gettingCoupon = true
      const { collectionCode } = this
      this.$http.post('/coupon/redeemCoupon', {
        collectionCode,
      }).then(() => {
        this.$message.success(i18n.t('upgrade_page_views_coupons_index_712'))
        this.$store.dispatch('app/getUserAccount')
        this.gettingCoupon = false
        this.showError = false
        this.requestList(['EFFECT'], 'couponsList')
        this.showCodeInput = false
      }).catch(({ code }) => {
        switch (code) {
          case 3008: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_713')
            break
          }
          case 3011: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_714')
            break
          }
          case 3012: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_715')
            break
          }
          case 3014: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_716')
            break
          }
          case 3015: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_717')
            break
          }
          default: {
            this.errorText = i18n.t('upgrade_page_views_coupons_index_718')
          }
        }
        this.showError = true
        this.gettingCoupon = false
      })
    },
    /**
     * @description: 获取用户優惠券
     */
    getCouponsList() {
      /* *
        EFFECT(1, "有效"),
        OCCUPY(2, "占用"),
        USED(3, "已使用"),
        EXPIRED(4, "已过期"),
        DELETED(5, "已删除");
      */
      this.requestList(['USED', 'EXPIRED'], 'invalidList');
      this.requestList(['EFFECT'], 'couponsList');
    },
    /**
     * @description: 請求數據
     */
    requestList(couponStatusList, listKey) {
      this.$http.post('coupon/getUserCouponInfo', {
        couponStatusList,
        userUuid: this.userInfo.uuid
      }).then(data => {
        if (data && data.data) {
          this[listKey] = data.data
          // const obj = {}
          // this[listKey] = data.data.reduce((rs, item) => {
          //   if (obj[item.uuid] === undefined) {
          //     obj[item.uuid] = rs.length
          //     item.count = 1
          //     rs.push(item)
          //   } else {
          //     rs[obj[item.uuid]].count += 1
          //   }
          //   return rs
          // }, [])
        }
      });
    },
    gotoPlayDetail(couponsInfo) {
      switch (couponsInfo.couponTemplate) {
        case 'NEWCOMER_EXPERIENCE':
          break;
        case 'NEW_EXCLUSIVE':
          this.$router.push({
            name: 'MasterDetail',
            params: {
              uuid: couponsInfo.playerUuid,
              skill: couponsInfo.skillId
            },
            query: {
              couponUuid: couponsInfo.uuid
            }
          });
          break;
        case 'CLOSE_EYES_WHEN_DARK': 
          this.$router.push({
            name: 'SkillList',
            query: {
              id: 35
            }
          });
          break;
        case 'REGRESS_LOL_COUPON': {
          this.$router.push({
            path: '/play',
            query: {
              id: 1,
              // tagId: 10,
            },
          })
          break
        }
        default: {
          this.$router.push({
            path: '/'
          })
          break
        }
      }
    },
    getValidityCalculationDesc(couponsInfo)  {
      return couponsInfo.deadline.slice(0, 10)
    }
  },
  created() {
    this.getCouponsList()
  }
};
</script>
<style lang="scss" scoped>
  .coupon-page {
    padding: 36px 0;
    overflow-y: auto;
  }
  .input-coupon-code {
    border-radius: 16px;
    background: #fff;
    @include flex(center, center, column);
    padding: 12px 12px 48px;
    .close-dialog {
      align-self: flex-end;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: $color-split;
      color: $color-gray-1;
    }
    .coupon-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: $color-gray-1;
      margin-top: 18px;
    }
    .code-err {
      font-size: 12px;
      line-height: 20px;
      color: $color-red;
      text-align: left;
      width: 315px;
      margin: 22px 0 8px;
    }
    .code-input {
      width: 315px;
      height: 48px;
      border: 1px solid #8C94AA;
      border-radius: 30px;
      padding-left: 20px;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      &::placeholder {
        font-weight: 500;
        color: $color-gray-3;
      }
      &.error-input {
        border-color: $color-red;
      }
    }
    .get-btn {
      width: 315px;
      height: 48px;
      border-radius: 26px;
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      background: $color-yellow;
      margin-top: 16px;
      color: $color-gray-1;
      &:disabled {
        background: $color-button !important;
        color: rgba($color: $color-gray-2, $alpha: .3) !important;
      }
    }
  }
  .tabs-container {
    height: 71px;
    position: relative;
    .get-coupons {
      position: absolute;
      top: 50%;
      right: 32px;
      width: 110px;
      height: 32px;
      border-radius: 20px;
      border: 2px solid rgba(34, 44, 67, 0.8);
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      transform: translateY(-50%);
    }
  }
  .tabs-wrap {
    height: 100%;
    & /deep/ .tabs-btn {
      margin-left: 70px;
      padding: 0 20px;
      font-weight: 500;
      font-size: 22px;
      line-height: 31px;
      color: $color-gray-1;
      &.active-button {
        color: $color-gray-1;
        &::after {
          height: 4px;
          border-radius: 4px;
          background: $color-yellow;
        }
      }
      &:first-child {
        margin-left: 40px;
      }
    }
  }
  .no-coupons-icon {
    width: 142px;
    height: 90px;
    margin: 0 auto 37px;
    background: url('~@/assets/image/background/empty-coupon.png');
    background-size: 100% 100%;
  }
  .user-coupons {
    overflow-y: auto;
    @include whiteBox;
    padding-bottom: 64px !important;
    overflow-y: auto;
  }
  .no-coupons {
    margin-top:156px;
    text-align: center;
    font-size: 18px;
    color:#666666;
  }
  .coupons-list-wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 0 0 20px;
    .coupon-bar {
      margin: 20px 0 0 20px;
      cursor: default;
    }
  }
  .goto-detail-button {
    display: inline-block;
    border-radius: 50px;
    width: 80px;
    height: 32px;
    @include flex;
    white-space: nowrap;
    cursor: pointer;
    color: $color-gray-1;
    background: $color-yellow;
  }
</style>
